import { Links } from "@/redux/types";

export enum CardLabel {
  PERSONAL = "personal",
  CORPORATE = "corporate",
}

export enum PaymentMethodType {
  CREDIT_CARD = "credit_card",
  INVOICE = "invoice",
}

export type CardData = {
  /** Masked number — only the last 4 digits are meaningful */
  number: string;
  expiry_month: number;
  expiry_year: number;
  issuer: string;
  /** User-set nickname; empty string when not set (backend reuses credit_card.name) */
  nickname: string;
};

export type ClientPaymentMethod = {
  uuid: string;
  type: PaymentMethodType;
  default: boolean;
  label: CardLabel;
  card_data: CardData | null;
  metadata: {
    in_use: boolean;
  };
};

export type GetClientPaymentMethodsRawResponse = {
  _embedded: {
    payment_method: ClientPaymentMethod[];
  };
  page_count: number;
  page_size: number;
  total_items: number;
  page: number;
  _links: Links;
};

export type GetClientPaymentProviderKeysRawResponse = {
  provider: string;
  setup_intent: string;
  ephemeral_key: string;
  customer: string;
  publishable_key: string;
  intent: string;
  intent_secret: string;
  _links: Links;
};

export type CardToggles = {
  card_personal_enabled: boolean;
  card_corporate_enabled: boolean;
};

export type ClientPaymentMethodArgs = {
  accountId: string;
  paymentMethodId: string;
  /** delete only: repoints this card's unpaid jobs to the replacement before deletion (card replace flow) */
  replacementId?: string;
};

export type GetClientPaymentProviderKeysArgs = {
  accountId: string;
  /** @deprecated DEV-1142 — backend auto-assigns type when no label is sent */
  label?: CardLabel;
};

export type UpdateCardNicknameArgs = {
  accountId: string;
  paymentMethodId: string;
  nickname: string;
};
